import { financeUrl } from '../api-urls';
import axios from 'axios';
import { path } from 'ramda';

function requestFinanceSegregation(id) {
  return {
    url: `${financeUrl}/${id}`,
    method: 'get'
  };
}
export const getFinanceSegregation = async ({ id }) => {
  try {
    const response = await axios(requestFinanceSegregation(id));
    const content = path(['data', 'customerSegregation'], response);

    return content;
  } catch (err) {
    console.error(err);
    return;
  }
};
